import React, {useMemo} from "react";
import {useParams} from "react-router-dom";
import TaskTable from "../../components/tables/TaskTable";
import _ from "lodash";
import {useListKpiTasksQuery} from "../../apis/kpiApi";

const KPITaskTable = ({canAddTasks}) => {
    const { target } = useParams();
    const {data: tasks, isLoading: isLoadingTasks} = useListKpiTasksQuery();
    
    const filteredTasks = useMemo(() => {
        if(!tasks || isLoadingTasks) {
            return [];
        }

        return _.cloneDeep(tasks || []).filter(task => task.parent === target);
    }, [tasks, isLoadingTasks, target]);


    

    if(target === 'new') {
        return (<></>);
    }

    return (
        <div className="kpi-task-table">
            <TaskTable tasks={filteredTasks}
                       loading={isLoadingTasks}
                       editTaskEndpoint={`task`} 
                       newSubTaskEndpoint={`task/new/parent-task`}
                       showCompleteDefaultStatus={true} 
                       newTaskEndpoint={canAddTasks? `task/new` : undefined}
                       />
        </div>
    )
}

export default KPITaskTable;
